import { StoredScheduleBlock } from './StoredScheduleBlock';

/**
 * Deep equality of two stored models: same blocks (todo + start), same order.
 * Order matters because the persisted array is kept schedule-sorted.
 */
export const modelsEqual = (
  a: StoredScheduleBlock[] | null,
  b: StoredScheduleBlock[] | null,
): boolean =>
  !!a && !!b && a.length === b.length &&
  a.every((entry, index) => entry.todo === b[index].todo && entry.start === b[index].start);
